// removed by extract-text-webpack-plugin
module.exports = {"textRoot":"index-textRoot-1ILVa","inlineText":"index-inlineText-2EQ4x","logout":"index-logout-Vj8ts","displayName":"index-displayName-3BMC-","login":"index-login-3Qn78"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account-info/index.less
// module id = 1047
// module chunks = 0 1